import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ParFormFieldComponent } from '@shared/ui';
import { DynamicFormControlDirective } from '../../dynamic-form-control.directive';
import { AbstractDynamicFormControl } from '../../abstact-dynamic-form-control.directive';
import { SafariTimeInputDirective, TimeService } from '@shared/utils';

@Component({
  selector: 'dynamic-form-time-control',
  templateUrl: 'time-control.component.html',
  styleUrls: ['time-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, ParFormFieldComponent, SafariTimeInputDirective],
  providers: [
    {
      provide: DynamicFormControlDirective,
      useExisting: DynamicFormTimeControlComponent,
    },
  ],
})
export class DynamicFormTimeControlComponent extends AbstractDynamicFormControl {
  private timeService = inject(TimeService);
  timeIntervals = this.timeService.createTimeIntervals(
    30,
    { hours: 6, minutes: 0 },
    { hours: 22, minutes: 0 },
  );
  timeOptions = this.timeIntervals.map((time) => this.timeService.timeToString(time));
}
